import React from 'react';
import { IItemForGetShortInfo } from 'types';
import {
	TEditVideoSelectedItem,
	TTypeOfEditVideoModalWindow,
} from '../../../../../../../editVideoState/editVideoContext';
import StudioSelect from './components/StudioSelect';
import CreateStudioBtn from './components/CreateStudioBtn';
import style from './StudioField.module.scss';

interface IStudioField {
	setFetchedStudios: (value: IItemForGetShortInfo[]) => void;
	setIDStudio: (value: TEditVideoSelectedItem) => void;
	refetchStudios: (value: boolean) => void;
	changeTypeOfModalWindow: (value: TTypeOfEditVideoModalWindow) => void;
	needRefetchStudios: boolean;
}

const StudioField: React.FC<IStudioField> = ({
	setFetchedStudios,
	setIDStudio,
	refetchStudios,
	changeTypeOfModalWindow,
	needRefetchStudios,
}) => {
	return (
		<div className={style.container}>
			<StudioSelect
				setFetchedStudios={setFetchedStudios}
				setIDStudio={setIDStudio}
				refetchStudios={refetchStudios}
				needRefetchStudios={needRefetchStudios}
			/>
			<CreateStudioBtn changeTypeOfModalWindow={changeTypeOfModalWindow} />
		</div>
	);
};

export default React.memo(StudioField);
